module.exports = __webpack_public_path__ + "static/slide-4-6d1250e49d21400d8a1c833b0f6ae76c.svg";